import { useState } from "react";
import { useAccountLogin } from "@made-people/grease-account";
import { useTranslate } from "@made-people/grease-translations";

export const useLoginForm = ({ onSuccess }: { onSuccess: () => void }) => {
  const translate = useTranslate();
  const { execute, loadingState } = useAccountLogin();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (loadingState === "loading") return;
    setError("");
    const result = await execute({ email, password });
    if (result.success) {
      onSuccess();
    } else if (result.error === "Account_InvalidEmail") {
      setError(translate("Account_InvalidEmail_Helper_Text"));
    } else if (result.error === "Account_MissingFields") {
      setError(translate("Account_MissingFields_Helper_Text"));
    } else if (result.error === "Account_InvalidCredentials") {
      setError(translate("Account_InvalidCredentials_Helper_Text"));
    } else {
      setError(translate(result.error));
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    error,
    handleSubmit,
    handleKeyDown,
    loadingState,
  };
};
